import PropTypes from "prop-types"
import { Modal, Button, Flex } from "antd"
import { ExclamationCircleFilled, FileTextOutlined } from "@ant-design/icons"
import styles from "./IncompleteDocumentsModal.module.css"

// Shown when a booking has unsigned required documents before check-in. The operator can
// cancel or override and check in anyway.
const IncompleteDocumentsModal = ({ open, onClose, missingDocuments = [], description, loading = false, onOverride }) => (
  <Modal open={open} onCancel={onClose} footer={null} width={360} centered>
    <Flex vertical align="center" gap={4} className={styles.header}>
      <ExclamationCircleFilled className={styles.warnIcon} />
      <span className={styles.title}>Incomplete Documents</span>
      <span className={styles.subtitle}>{description || "Review missing documents before check-in"}</span>
    </Flex>

    {missingDocuments.length > 0 && (
      <Flex vertical gap={8} className={styles.docList}>
        {missingDocuments.map((doc) => (
          <Flex key={doc.id ?? doc.title} align="center" justify="space-between" className={styles.docRow}>
            <Flex align="center" gap={6}>
              <FileTextOutlined className={styles.docIcon} />
              <span className={styles.docTitle}>{doc.title}</span>
            </Flex>
            <span className={styles.missing}>Missing</span>
          </Flex>
        ))}
      </Flex>
    )}

    <Flex gap={8} justify="flex-end" className={styles.footer}>
      <Button shape="round" onClick={onClose}>
        Cancel
      </Button>
      <Button type="primary" shape="round" onClick={onOverride} loading={loading}>
        Override &amp; Check-in
      </Button>
    </Flex>
  </Modal>
)

IncompleteDocumentsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  missingDocuments: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), title: PropTypes.string })
  ),
  description: PropTypes.string,
  loading: PropTypes.bool,
  onOverride: PropTypes.func
}

export default IncompleteDocumentsModal
